import { type FC } from "react";
import { ConfirmationModal } from "../../../../layout/ConfirmationModal";

export type DeleteRequestConfirmationProps = {
	title: string;
	/** Received and closed requests already carry a record, so they skip the keep-a-record nudge. */
	resolved?: boolean;
	testId: string;
	onCancel: () => void;
	onConfirm: () => void;
};

export const DeleteRequestConfirmation: FC<DeleteRequestConfirmationProps> = ({
	title,
	resolved = false,
	testId,
	onCancel,
	onConfirm,
}) => (
	<ConfirmationModal
		closeOnEscape
		message={`Delete "${title}"?`}
		subMessage={
			resolved
				? "Use this for requests made in error. It leaves the received and closed list."
				: "Use this for requests made in error. To keep a record, mark it received or close it instead."
		}
		confirmButtonText="Delete"
		confirmButtonTestId={`${testId}-delete-confirm`}
		confirmationButtonColor="danger"
		onCancel={onCancel}
		onConfirm={onConfirm}
	/>
);
